module.exports = __webpack_public_path__ + "img/VENUS.597f3797.png";